import React from 'react';
import noop from 'lodash/noop';
var RichContentContext = React.createContext({
    theme: {},
    anchorTarget: '',
    relValue: '',
    config: {},
    t: noop,
    setEditorState: noop,
    locale: 'en',
    helpers: {},
    languageDir: 'ltr',
});
RichContentContext.displayName = 'RichContentContext';
var Provider = RichContentContext.Provider, Consumer = RichContentContext.Consumer;
export default {
    type: RichContentContext,
    Provider: Provider,
    Consumer: Consumer,
};
//# sourceMappingURL=Context.js.map